module.exports = __webpack_public_path__ + "static/img/hangyeli6.8dc7c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/hangyeli6.png
// module id = GaNO
// module chunks = 5